const DoubleField = ({
  label,
  name,
  value,
  compulsory = false,
  noGaps = false,
  error,
  ...props
}) => (
  <div className={`formgroup ${noGaps ? "" : "mt-3"}`}>
    <label className="label">{label}</label>

    <div className="flex">
      <input
        type="number"
        className={`input ${noGaps ? "input-full" : ""}`}
        name={name}
        value={value}
        {...props}
      />
      {compulsory && <span className="label-imp">*</span>}
    </div>
    {error && !noGaps ? (
      <p className="label-error">{error}</p>
    ) : (
      error && <p className="label-error-pos">{error}</p>
    )}
  </div>
);

export default DoubleField;
